<template>
  <div class="content">
    <div class="row animated fadeIn">
      <div class="col-md-12">
        <div class="card">
          <div class="card-header">
            <h4 class="card-title">All Feedbacks</h4>
            <ul class="nav nav-tabs" id="myTab" role="tablist">
              <li class="nav-item">
                <a class="nav-link active show" id="active-tab"
                   data-toggle="tab" href="#active" role="tab" aria-controls="up">Active</a>
              </li>
              <li class="nav-item">
                <a class="nav-link" id="resolved-tab" data-toggle="tab"
                   href="#articles" role="tab" aria-controls="down">Article Feedbacks</a>
              </li>
              <li class="nav-item">
                <a class="nav-link" id="resolved-tab" data-toggle="tab"
                   href="#resolve" role="tab" aria-controls="down">Resolved</a>
              </li>
            </ul>
          </div>
          <div class="card-body" style="padding-top: 0 !important;">
            <div class="tab-content customer-table mt-20">
              <div id="active" class="tab-pane active show">
                <feedbackList v-if="!initialLoader" @resolve="resolve" tab="pending" @openDetailModal="openModal" tableId="activeFeedback" :list="activeFeedback" />
                <div class="loader" v-else></div>
              </div>
              <div id="articles" class="tab-pane fade">
                <feedbackList v-if="!initialLoader" @resolve="resolve" @checkin="checkinArticle" tab="articles" @openDetailModal="openModal" tableId="articleFeedback" :list="suggestedArticles" />
                <div class="loader" v-else></div>
              </div>
              <div id="resolve" class="tab-pane fade">
                <feedbackList v-if="!initialLoader" @openDetailModal="openModal" tab="resolved" :list="resolvedFeedback" tableId="resolvedFeedback" />
                <div class="loader" v-else></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="modal_body">
      <div class="modal" tabindex="-1" role="dialog" id="detailsModal" aria-hidden="true">
        <div class="modal-dialog modal-lg" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h6 class="modal-title">
                Feedback from {{selectedFeedback.fullName}}
              </h6>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <div class="row">
                <div class="col-md-9">
                  <b>NAME:</b> {{selectedFeedback.fullName}} <br> <br>
                  <b>EMAIL:</b> {{selectedFeedback.email}} <br> <br>
                  <b>REACTION:</b> {{getReaction(selectedFeedback.emojiReaction)}} <br> <br>
                  <h6 v-if="selectedFeedback.files && selectedFeedback.files.length">Attachments:</h6>
                    <ol v-if="selectedFeedback.files && selectedFeedback.files.length">
                      <li v-for="(row, index) in selectedFeedback.files" :key="index">
                        <a :href="row.url" target="_blank">{{ row.name }}</a>
                      </li>
                    </ol>
                </div>
                <div v-if="selectedFeedback.emojiReaction" class="col-md-3 d-flex align-items-center">
                  <vue-reaction-emoji :is-active="true" width="90px" height="90px"  :reaction="selectedFeedback.emojiReaction" />
                </div>
              </div>
              <h6>{{ selectedFeedback.type === 'article_suggestion' || selectedFeedback.type === 'article_feedback' ? (selectedFeedback.type === 'article_suggestion' ? 'Suggestion' : `Feedback on article #${selectedFeedback.article.id}`)   : 'Feedback' }}:</h6>
              <code>
                {{ selectedFeedback.article ? selectedFeedback.article.title : selectedFeedback.comment }}
              </code>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import feedbackList from "@/components/Admin/ClientFeedbacks/feedbackList";
import {db} from "@/firebase/init";
import { VueReactionEmoji } from 'vue-feedback-reaction';
export default {
  name: "index",
  components: {
    feedbackList,
    VueReactionEmoji
  },
  mounted () {
    this.initialLoader = true;
    this.getFeedbackList()
  },
  data () {
    return {
      activeTab: null,
      feedbackList: [],
      selectedFeedback: {},
      initialLoader: false,
      initTables: false
    }
  },
  computed: {
    activeFeedback () {
      return this.feedbackList.filter(el => el.status === 'pending' && (!el.type || el.type === 'client_feedback'));
    },
    resolvedFeedback () {
      return this.feedbackList.filter(el => el.status === 'resolved');
    },
    suggestedArticles () {
      return this.feedbackList.filter(el => el.status === 'pending' && (el.type === 'article_suggestion' || el.type === 'article_feedback'));
    },
    user () {
      return this.$store.getters.user;
    }
  },
  watch: {
    activeFeedback () {
      console.log('Change occur in active');
      this.reInitDataTable();
    },
    resolvedFeedback () {
      console.log('Change occur in resolved ');
      this.reInitDataTable();
    },
    suggestedArticles () {
      console.log('Change occur in resolved ');
      this.reInitDataTable();
    }
  },
  updated() {
    if(this.initTables){
      this.initTable('activeFeedback');
      this.initTable('resolvedFeedback');
      this.initTable('articleFeedback');
      this.initTables = false;
    }
  },
  methods: {
    reInitDataTable(){
      /* eslint-disable */
      $(`#activeFeedback`).DataTable().destroy();
      $(`#resolvedFeedback`).DataTable().destroy();
      $(`#articleFeedback`).DataTable().destroy();
      /* eslint-enable */
      this.initTables = true;
    },
    initTable(el) {
      console.log('Loading datatable');
      /* eslint-disable */
      // if($.fn.DataTable.isDataTable( `#${el}` )){
      // 	$(`#${el}`).DataTable().destroy();
      // }
      $(`#${el}`).DataTable({
        pagingType: "full_numbers",
        lengthMenu: [[10, 25, 50, -1], [10, 25, 50, "All"]],
        destroy: true,
        retrieve: true,
        deferRender: true,
        "ordering": false,
        stateSave: true,
        language: {
          search: "_INPUT_",
          searchPlaceholder: "Search",
          size: 50
        }
      });
      /* eslint-enable */
    },
    async resolve (data) {
      await db.collection('clientFeedbacks').doc(data.id).update({
        status: 'resolved',
        resolvedBy: this.user.firstName + ' ' + this.user.lastName
      });
      await this.getFeedbackList()
    },
    async checkinArticle (data) {
      await db.collection('clientFeedbacks').doc(data.id).update({
        checkInBy: this.user.firstName + ' ' + this.user.lastName
      });
      await this.getFeedbackList()
    },
    openModal (data) {
      this.selectedFeedback = data;
      $("#detailsModal").modal("show");
      $('.modal-backdrop').removeClass("modal-backdrop");
    },
    getReaction(reaction) {
      if(reaction) {
        if (reaction === 'hate') {
          return 'Angry';
        } else if (reaction === 'disappointed') {
          return 'Disappointed';
        } else if (reaction === 'natural') {
          return 'Neutral';
        } else if (reaction === 'good') {
          return 'Good';
        } else if (reaction === 'excellent') {
          return 'Excellent';
        }
      }
    },
    async getFeedbackList () {
      try {
        this.loading = true;
        const ref= await db.collection('clientFeedbacks').orderBy("createdAt", "desc").get();
        this.feedbackList = [];
        if (ref.size) {
          ref.forEach(el => {
            this.feedbackList.push({id: el.id, ...el.data()})
          })
        }
        this.loading = false;
      }
      catch (e) {
        this.loading = false;
      } finally {
        this.initialLoader = false;
      }
    }
  }
}
</script>

<style scoped>
::v-deep .dataTables_wrapper .dataTables_filter input::-webkit-search-cancel-button {
  -webkit-appearance: button !important;
}
.nav-tabs .nav-item .nav-link.active:before,
.nav-tabs .nav-item .nav-link.active:hover:before,
.nav-tabs .nav-item .nav-link.active:focus:before {
  border: 0;
}

.nav-tabs {
  border-bottom: 1px solid #dee2e6;
}

.nav-tabs .nav-link {
  border: 1px solid transparent !important;
  border-top-left-radius: .25rem;
  border-top-right-radius: .25rem;
}

.nav-tabs .nav-item.show .nav-link, .nav-tabs .nav-link.active {
  color: #495057;
  background-color: #fff;
  border-color: #dee2e6 #dee2e6 #fff !important;
}

.nav-tabs .nav-item .nav-link.active {
  color: #5B7CFB;
}
code {
  background: #f4f4f4;
  border: 1px solid #ddd;
  border-left: 3px solid #2954fa;
  color: #666;
  page-break-inside: avoid;
  font-family: monospace;
  font-size: 12px;
  line-height: 1.6;
  margin-bottom: 1.6em;
  max-width: 100%;
  overflow: auto;
  padding: 1em 1.5em;
  display: block;
  word-wrap: break-word;
}
code .info{
  color: #376c4f;
}
code .danger{
  color: #cf363e;
}
</style>
